import { Button } from '@repo/videa-components/src/index';
import { NoteGenerationError, SheetFooter } from '@repo/videa-notes';

import type { VideaNotesProcessingError } from '../../../types';

import { SlideOutViewLayout } from '../SlideOutViewLayout';

interface NoteErrorViewProps {
  error: VideaNotesProcessingError;
  onDismiss: () => void;
}

export const NoteErrorView = ({ error, onDismiss }: NoteErrorViewProps) => (
  <SlideOutViewLayout
    footer={
      <SheetFooter className="vai-justify-start">
        <Button onClick={onDismiss} variant="destructive">
          <span>Dismiss</span>
        </Button>
      </SheetFooter>
    }
  >
    <NoteGenerationError {...error} />
  </SlideOutViewLayout>
);
